<template>
  <section class="dte-standard-recipient">
    <table class="dte-standard-table dte-standard-table--plain dte-standard-table--recipient">
      <tbody>
        <tr v-for="(row, index) in rows" :key="`recipient-row-${index}`">
          <td class="dte-standard-table__label dte-standard-table__label--inline">{{ row.leftLabel }}</td>
          <td class="dte-standard-table__multiline">{{ row.leftValue }}</td>
          <template v-if="row.rightLabel">
            <td class="dte-standard-table__label dte-standard-table__label--inline">{{ row.rightLabel }}</td>
            <td>{{ row.rightValue }}</td>
          </template>
          <td v-else colspan="2"></td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { getStandardRecipientRows } from "../utils/dtePrintStandard";

export default {
  name: "DteStandardRecipientSection",
  props: {
    documentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    rows() {
      return getStandardRecipientRows(this.documentData);
    },
  },
};
</script>
